"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bufferToRawString = exports.bytifyRawString = void 0;
const codec_1 = require("@ckb-lumos/codec");
const encoder = new TextEncoder();
const decoder = new TextDecoder();
function bytifyRawString(text) {
    return encoder.encode(text);
}
exports.bytifyRawString = bytifyRawString;
function bufferToRawString(source, options) {
    const buffer = codec_1.bytes.bytify(source);
    return decoder.decode(buffer, options);
}
exports.bufferToRawString = bufferToRawString;
//# sourceMappingURL=buffer.js.map